<template>
    <footer class="bg-beige-light pt-24 pb-12 border-t border-umber/5" role="contentinfo">
        <div class="max-w-[1200px] mx-auto px-8">
            <div class="grid md:grid-cols-4 gap-12 mb-20">

                <div class="col-span-2 text-umber">
                    <h4 class="font-cormorant text-2xl mb-4 italic">Soulful Bloom</h4>
                    <p class="text-xs text-umber/50 leading-loose max-w-xs font-inter">
                        Dorothée Armbruster <br />
                        Créatrice d’expériences bien-être immersives. <br />
                        Bordeaux, France.
                    </p>
                </div>

                <nav class="space-y-4 text-[10px] uppercase tracking-widest text-umber/60 font-inter"
                    aria-label="Navigation de pied de page">
                    <p class="text-umber font-bold mb-6 tracking-[0.2em]">Menu</p>
                    <RouterLink :to="{ name: 'AboutPage' }"
                        class="block hover:text-gold-brush transition-colors duration-300">Mon histoire</RouterLink>
                    <RouterLink :to="{ name: 'HomePage', hash: '#about' }"
                        class="block hover:text-gold-brush transition-colors duration-300">Soulful Bloom</RouterLink>
                    <RouterLink :to="{ name: 'OnlinePage' }"
                        class="block hover:text-gold-brush transition-colors duration-300">En ligne</RouterLink>
                    <RouterLink :to="{ name: 'ProfessionalPage' }"
                        class="block hover:text-gold-brush transition-colors duration-300">Professionnels</RouterLink>
                    <RouterLink :to="{ name: 'PartnershipsPage' }"
                        class="block hover:text-gold-brush transition-colors duration-300">Partenariats</RouterLink>
                    <RouterLink :to="{ name: 'ContactPage' }"
                        class="block hover:text-gold-brush transition-colors duration-300">Contact</RouterLink>
                    <a href="/#faq" class="block hover:text-gold-brush transition-colors duration-300">FAQ</a>
                </nav>

                <nav class="space-y-4 text-[10px] uppercase tracking-widest text-umber/60 font-inter"
                    aria-label="Réseaux sociaux">
                    <p class="text-umber font-bold mb-6 tracking-[0.2em]">Get Social</p>
                    <a href="https://www.instagram.com/dorothee.armbruster/" target="_blank" rel="noopener noreferrer"
                        class="block hover:text-gold-brush transition-colors duration-300">Instagram</a>
                    <a href="https://www.facebook.com/dorothee.soulfulbloom" target="_blank" rel="noopener noreferrer"
                        class="block hover:text-gold-brush transition-colors duration-300">Facebook</a>
                    <a href="https://www.linkedin.com/in/doroth%C3%A9e-armbruster-charreton-/" target="_blank"
                        rel="noopener noreferrer"
                        class="block hover:text-gold-brush transition-colors duration-300">Linkedin</a>
                </nav>
            </div>

            <div
                class="flex flex-col md:flex-row justify-between items-center gap-6 pt-12 border-t border-umber/10 text-[9px] uppercase tracking-[0.2em] text-umber/40 font-inter">
                <p>© {{ new Date().getFullYear() }} Soulful Bloom — Tous droits réservés.</p>
                <div class="flex gap-8">
                    <RouterLink :to="{ name: 'MentionsPage' }" class="hover:text-umber transition-colors duration-300">
                        Mentions Légales</RouterLink>
                    <RouterLink :to="{ name: 'CgvPage' }" class="hover:text-umber transition-colors duration-300">CGV
                    </RouterLink>
                    <RouterLink :to="{ name: 'PrivacyPage' }" class="hover:text-umber transition-colors duration-300">
                        Confidentialité</RouterLink>
                    <RouterLink :to="{ name: 'ChartePage' }" class="hover:text-umber transition-colors duration-300">
                        Charte de déontologie</RouterLink>
                </div>
            </div>
        </div>
    </footer>
</template>